import React, { Component } from "react";
import { connect } from "react-redux";
import * as qs from "query-string";
import { history, isValidStartDate, isValidEndDate } from "../../_helpers";
import { api } from "../../_services";
import MenuBar from "../MenuBar";
import NoteCard from "../NoteCard";
import PrecinctDropdown from "../PrecinctDropdown";
import DeviceDropdown from "../DeviceDropdown";
import StatusCheckBox from "../StatusCheckBox";
import DateTimePicker from "../DateTimePicker";
import SensorTypeCheckBox from "../SensorTypeCheckBox";
import NoteMergeTargetDropdown from "../NoteMergeTargetDropdown";
import NoteOriginDropdown from "../NoteOriginDropdown";
import FilterMenuBar from "../FilterMenuBar";
import Pagination from "../Pagination";
import AlertTypeCheckBox from "../AlertTypeCheckBox";
import ResolutionCategoryDropdown from "../ResolutionCategoryDropdown";
import FontAwesome from "react-fontawesome";
import NoteSmallIcon from "../../_icons/NoteSmallIcon";
import _ from "lodash";
import { pageNotes, sidebarOff, modalAlert, selectNotes, deselectNotes, clearSelectedNotes } from "../../_actions";
import "react-table/react-table.css";
import "./index.css";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { Button, Row, Col, form, FormGroup, ControlLabel, FormControl, Modal, HelpBlock, Dropdown } from "react-bootstrap";

class AllNotePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newNoteName: "",
      resolutionCategory: "",
      validated: false,
      resolutionDescriptionCheck: false,
      resolution: "",
      allNotesList: [],
      pages: null,
      loading: false,
      filterOpen: false,
      resetFilter: false,
      listLoading: false,
      filtered: false,
      showIDInput: false,
      params: {}
    };
  }

  componentDidMount = () => {
    this.setState(() => {
      return {
        loading: true
      };
    });
    this.props.sidebarOff();
    //set current page to note
    this.props.pageNotes();
    if (this.props.location.search) {
      const params = qs.parse(this.props.location.search);
      this.getAllNotes(params);
    } else {
      this.getAllNotes();
    }
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.location.search !== nextProps.location.search && nextProps.location.search === "") {
      this.resetFilter();
    }
  };

  componentDidUpdate() {
    if (this.allTitleCheckbox) {
      if (this.areAllNotesOnPageChecked() === null) {
        this.allTitleCheckbox.indeterminate = true;
      } else {
        this.allTitleCheckbox.indeterminate = false;
      }
    }
  }

  /* Retrieve all notes */
  getAllNotes = p => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });
    const url = "/api/v1/notes/";
    const params = {};
    if (p) {
      for (const key in p) {
        params[key] = p[key];
      }
      this.setState(() => {
        return {
          params: params,
          showIDInput: params.id ? true : false
        };
      });
    } else {
      // clear the url params
      if (this.props.location.search) {
        history.push({
          pathname: this.props.location.pathname,
          search: ""
        });
      }
    }
    const errorMsg = "Unable to retrieve notes.";
    api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
      const filtered = this.checkFiltered();
      this.setState(() => {
        return {
          allNotesList: json.results,
          count: json.count,
          page_size: json.page_size,
          num_pages: json.num_pages,
          current_page: json.current_page,
          loading: false,
          listLoading: false,
          filtered: filtered
        };
      });
    });
  };

  filterNote = (reset, page) => {
    this.setState(() => {
      return {
        listLoading: true
      };
    });

    // clear selected notes on filter
    if (!reset && !page) {
      this.props.clearSelectedNotes();
    }

    const url = "/api/v1/notes/";
    const params = {};
    if (!reset) {
      if (!this.state.params.id) {
        this.setState(() => {
          return {
            showIDInput: false
          };
        });
      }

      for (const key in this.state.params) {
        if (this.state.params[key] !== "") {
          params[key] = this.state.params[key];
        }
      }

      if (page) {
        params.page = page;
      } else {
        delete params["page"];
      }
    }
    if (this.checkFiltered() || !reset) {
      const errorMsg = "Unable to retrieve notes.";
      let filtered = false;

      filtered = this.checkFiltered();
      api.getFetch(url, params, this.props.user.token, errorMsg).then(json => {
        this.setState(() => {
          return {
            allNotesList: json.results,
            count: json.count,
            page_size: json.page_size,
            num_pages: json.num_pages,
            current_page: json.current_page,
            loading: false,
            listLoading: false,
            filtered: filtered ? true : false
          };
        });
      });
      this.openFilter(false);
    } else if (reset) {
      this.setState(() => {
        return {
          loading: false,
          filtered: reset ? false : true
        };
      });
    }

    const queryParams = api.queryParams(params);
    if (queryParams) {
      history.push({
        pathname: this.props.location.pathname,
        search: "?" + queryParams
      });
    } else {
      history.push({
        pathname: this.props.location.pathname,
        search: ""
      });
    }
  };

  checkFiltered = () => {
    let filtered = false;
    for (const key in this.state.params) {
      if (Array.isArray(this.state.params[key]) && this.state.params[key].length > 0) {
        filtered = true;
      } else if (this.state.params[key]) {
        filtered = true;
      }
    }
    return filtered;
  };

  setPermissionForMergeNotesButton = () => {
    return _.reduce(
      _.map(this.props.selectedNoteList, note => note.can_be_merged),
      (accumulator, currentValue) => accumulator && currentValue
    );
  };

  setPermissionForResolveNotesButton = () => {
    return _.reduce(
      _.map(this.props.selectedNoteList, note => note.can_be_resolved),
      (accumulator, currentValue) => accumulator && currentValue
    );
  };

  findNoteById = id => {
    const { selectedNoteList } = this.props;
    return _.find(selectedNoteList, n => id === n.id);
  };

  toggleNote = toggledId => {
    const { selectNotes, deselectNotes } = this.props;
    const isNoteSelected = this.findNoteById(toggledId);
    if (!isNoteSelected) {
      const noteToggled = _.find(this.state.allNotesList, n => toggledId === n.id);
      if (noteToggled) {
        const { id, can_be_merged, can_be_resolved } = noteToggled;
        selectNotes([{ id, can_be_merged, can_be_resolved }]);
      }
    } else {
      deselectNotes([toggledId]);
    }
  };

  createNoteCard = (item, key) => {
    return <NoteCard key={item.id} item={item} action={this.toggleNote} selectedNote={!!this.findNoteById(key)} />;
  };

  renderAddNewNoteBtn = noteCreatePermission => {
    if (noteCreatePermission) {
      return (
        <div className="pull-right btnCon">
          <Link to={"/note/add"}>
            <Button className="btn btn-primary pull-left">Add a new note</Button>
          </Link>
        </div>
      );
    } else {
      return null;
    }
  };

  toggleAllNotesOnPage = () => {
    const { selectedNoteList, selectNotes, deselectNotes } = this.props;
    const { allNotesList } = this.state;

    // check if no notes toggled -> select all notes
    if (this.areAllNotesOnPageChecked() === false) {
      const notesToAdd = allNotesList.map(note => {
        const { id, can_be_merged, can_be_resolved } = note;
        return { id, can_be_merged, can_be_resolved };
      });

      selectNotes(notesToAdd);
    } else {
      // check if some or all notes toggled -> deselect all notes
      const notesToRemove = _.intersection(allNotesList.map(note => note.id), selectedNoteList.map(note => note.id));
      deselectNotes(notesToRemove);
    }
  };

  areAllNotesOnPageChecked = () => {
    const { selectedNoteList } = this.props;
    const { allNotesList } = this.state;

    if (allNotesList.length < 1) {
      return false;
    }

    const selectedNoteListIds = selectedNoteList.map(note => note.id);
    const allNotesListIds = allNotesList.map(note => note.id);

    const someChecked = _.difference(allNotesListIds, selectedNoteListIds).length < allNotesList.length;
    const allChecked = _.difference(allNotesListIds, selectedNoteListIds).length === 0;
    // check if no notes toggled -> false
    // can't check for empty list as selected notes can come from another page
    if (!someChecked) {
      return false;
    }

    // check if all notes toggled -> true
    if (allChecked) {
      return true;
    }

    // if some notes toggled -> indeterminate
    return null;
  };

  mergeNotes = () => {
    this.setState(() => {
      return {
        showMapModal: true,
        newNoteName: "",
        validated: false,
        targetNote: null
      };
    });
  };

  resolveNotes = () => {
    this.setState({ showResolveNotesModal: true, validated: false });
  };

  handleClose = () => {
    this.setState({ showMapModal: false, showResolveNotesModal: false });
  };

  setTargetNote = val => {
    this.setState(() => {
      return {
        targetNote: val ? val.id : null
      };
    });
  };

  onChange = e => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(() => {
      return { state };
    });
  };

  submitMergeForm = () => {
    this.setState(() => {
      return { validated: true };
    });

    if ((this.state.targetNote && this.state.newNoteName) || (!this.state.targetNote && !this.state.newNoteName)) {
      return;
    }
    this.submitAction();
  };

  submitResolveForm = () => {
    const { resolutionCategory, resolution, resolutionDescriptionCheck } = this.state;

    this.setState({ validated: true });

    if (!resolutionCategory) {
      return;
    }

    if (resolutionDescriptionCheck) {
      if (resolution !== null && resolution.length > 0) {
        this.resolveMultipleNotes();
      }
    } else {
      this.resolveMultipleNotes();
    }
  };

  resolveMultipleNotes = () => {
    const { resolutionCategory, resolution } = this.state;
    const url = "/api/v1/notes/resolve_multiple/";
    const errorMsg = "Unable to resolve multiple notes.";
    let params = {};

    this.setState({ waitingForResponse: true });
    const selectedNoteListIds = _.map(this.props.selectedNoteList, selectedNote => {
      return selectedNote.id;
    });
    if (resolution) {
      params = {
        resolution_description: resolution,
        resolution_category: resolutionCategory,
        notes_to_be_resolved: selectedNoteListIds
      };
    } else {
      params = {
        resolution_category: resolutionCategory,
        notes_to_be_resolved: selectedNoteListIds
      };
    }

    api.postFetch(url, params, this.props.user.token, errorMsg, true).then(json => {
      this.setState(() => {
        return { waitingForResponse: false, showResolveNotesModal: false, validated: false };
      });

      if (json.success) {
        this.getAllNotes();
      }
    });
  };

  submitAction = () => {
    const url = "/api/v1/notes/merge_multiple/";
    const errorMsg = "Unable to merge multiple notes.";

    this.setState(() => {
      return { waitingForResponse: true };
    });
    const selectedNoteListIds = _.map(this.props.selectedNoteList, selectedNote => {
      return selectedNote.id;
    });

    const params = {
      merge_type: this.state.targetNote ? "target" : "new_note",
      notes_to_be_merged: selectedNoteListIds
    };

    if (this.state.targetNote) {
      params.target_note = this.state.targetNote;
    }

    if (this.state.newNoteName) {
      params.new_note_title = this.state.newNoteName;
    }

    api.postFetch(url, params, this.props.user.token, errorMsg, true).then(json => {
      this.setState(() => {
        return { waitingForResponse: false };
      });

      if (json.success) {
        this.setState({ redirect: "/note/" + json.merge.target + "/view" });
      }
    });
  };

  checkFormValidation = () => {
    if (!this.state.validated) {
      return null;
    }

    if (this.state.validated) {
      if ((this.state.newNoteName && this.state.targetNote) || (!this.state.newNoteName && !this.state.targetNote)) {
        return "error";
      } else {
        return null;
      }
    }
  };

  setResolutionCategory = val => {
    this.setState({
      resolutionCategory: val ? val.id : null,
      resolutionDescriptionCheck: val ? val.requires_description : false
    });
  };

  renderResolutionCategoryDropdown = () => {
    const { validated, resolutionCategory } = this.state;

    return (
      <FormGroup validationState={validated && !resolutionCategory ? "error" : null}>
        <ResolutionCategoryDropdown change={this.setResolutionCategory} isBulkResolve={true} />
        {validated && !resolutionCategory ? (
          <div className="errorMsgCon">
            <HelpBlock>
              <FontAwesome name="exclamation-circle" /> Please select a resolution category.
            </HelpBlock>
          </div>
        ) : null}
      </FormGroup>
    );
  };

  renderResolutionDescriptionTextBox = () => {
    const { validated, resolutionDescriptionCheck, resolution } = this.state;

    return (
      <FormGroup validationState={resolutionDescriptionCheck ? (validated && !resolution ? "error" : null) : null}>
        <ControlLabel>
          Resolution Description
          {resolutionDescriptionCheck ? "*" : null}
        </ControlLabel>
        <FormControl
          componentClass="textarea"
          placeholder="Describe the resolution achieved"
          name="resolution"
          value={resolution}
          onChange={this.onChange}
        />
        {resolutionDescriptionCheck ? (
          validated && !resolution ? (
            <div className="errorMsgCon">
              <HelpBlock>
                <FontAwesome name="exclamation-circle" /> Please enter a resolution.
              </HelpBlock>
            </div>
          ) : null
        ) : null}
      </FormGroup>
    );
  };

  renderResolveNotesModal = (showResolveNotesModal, handleClose) => {
    const { selectedNoteList } = this.props;
    return (
      <Modal className="modal-dialog-bulk" show={showResolveNotesModal} onHide={handleClose} bsSize="large">
        <Modal.Header>
          <Modal.Title>Resolve Notes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="action-title-description">
            You are resolving {selectedNoteList.length} {selectedNoteList.length > 1 ? "notes" : "note"}. Select a
            resolution category, add any additional information about
            {selectedNoteList.length > 1 ? " these notes" : " this note"}, and then select Resolve
          </div>
          {this.renderResolutionCategoryDropdown()}
          {this.renderResolutionDescriptionTextBox()}
        </Modal.Body>
        <Modal.Footer>
          <div className="buttonContainer">
            <Button className="btn-cancel" bsStyle="default" onClick={() => this.handleClose()}>
              Cancel
            </Button>
            <Button className="btn-filter" bsStyle="primary" onClick={() => this.submitResolveForm()}>
              Resolve
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  renderModal = (showMapModal, handleClose) => {
    const { selectedNoteList } = this.props;
    const { newNoteName } = this.state;
    return (
      <Modal className="modal-dialog-bulk" show={showMapModal} onHide={handleClose} bsSize="large">
        <Modal.Header>
          <Modal.Title>Merge Notes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="action-title">Create a new note</div>
          <div className="action-title-description">
            The {selectedNoteList.length} selected {selectedNoteList.length > 1 ? "notes" : "note"} will be merged into
            the new note.
          </div>
          <FormGroup controlId="formBasicText" className="action-form" validationState={this.checkFormValidation()}>
            <ControlLabel>New note name</ControlLabel>
            <FormControl
              type="text"
              placeholder="Enter name"
              name="newNoteName"
              value={newNoteName}
              onChange={this.onChange}
            />
          </FormGroup>
          <div className="line-separator">
            <span>OR</span>
          </div>
          <div className="action-title">Select target note</div>
          <div className="action-title-description">
            The {selectedNoteList.length} selected {selectedNoteList.length > 1 ? "notes" : "note"} will be merged into
            the target note.
          </div>
          <FormGroup controlId="formBasicText" validationState={this.checkFormValidation()}>
            <NoteMergeTargetDropdown change={this.setTargetNote} />
            {this.checkFormValidation() ? (
              <HelpBlock>Please choose to either create a new note OR select a target note.</HelpBlock>
            ) : null}
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <div className="buttonContainer">
            <Button className="btn-cancel" bsStyle="default" onClick={() => this.handleClose()}>
              Cancel
            </Button>
            <Button className="btn-filter" bsStyle="primary" onClick={() => this.submitMergeForm()}>
              Merge
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  renderObservationButton = () => {
    return (
      <Link to={"/createObservation"}>
        <Button bsStyle="primary" className="btn-observation">
          <NoteSmallIcon className="small-icon" stroke="#ffffff" />Log an observation
        </Button>
      </Link>
    );
  };

  renderMainTitle = (noteCreatePermission, data) => {
    if (!data) {
      return null;
    }

    const { configList } = this.props;
    let observationButton;

    if (!configList || !configList.permissions.observations || configList.permissions.observations.length < 1) {
      observationButton = null;
    } else {
      observationButton = this.renderObservationButton();
    }

    let areAllNotesOnPageChecked = this.areAllNotesOnPageChecked();
    if (areAllNotesOnPageChecked === null) {
      areAllNotesOnPageChecked = true;
    }

    return (
      <div className="mainTitleCon">
        <div className="mainTitle">
          <h1>

            Notes {"(" + this.state.count + ")"}

          </h1>
        </div>
        <div className="titleBtnCon">
          <div className="mergeCon allCheckbox">
            <input
              type="checkbox"
              ref={el => (this.allTitleCheckbox = el)}
              name="all-notes-checkbox"
              className="checkbox all-checkbox"
              value="all-notes-checked"
              onChange={this.toggleAllNotesOnPage}
              checked={areAllNotesOnPageChecked}
            />
          </div>
          {this.props.noteMergePermission ? (
            <div className="mergeCon hidden-xs hidden-sm">
              <Button
                bsStyle="primary"
                disabled={!this.setPermissionForMergeNotesButton()}
                onClick={() => this.mergeNotes()}
              >
                Merge Notes
              </Button>
            </div>
          ) : null}
          {this.props.noteBulkResolvePermission ? (
            <div className="mergeCon hidden-xs hidden-sm">
              <Button
                bsStyle="primary"
                disabled={!this.setPermissionForResolveNotesButton()}
                onClick={() => this.resolveNotes()}
              >
                Resolve Notes
                </Button>
            </div>
          ) : null}
          <div className="mergeCon hidden-xs hidden-sm">{observationButton}</div>
          <div className="mergeCon hidden-lg hidden-md">
            <Dropdown id="dropdown-menu">
              <Dropdown.Toggle bsStyle="default" className="btn-primary">
                Action
              </Dropdown.Toggle>
              <Dropdown.Menu className="btn-menu">
                {this.props.noteMergePermission ? (
                  <Button
                    bsStyle="primary"
                    disabled={!this.setPermissionForMergeNotesButton()}
                    onClick={() => this.mergeNotes()}
                  >
                    Merge Notes
                  </Button>
                ) : null}
                {this.props.noteBulkResolvePermission ? (
                  <Button
                    bsStyle="primary"
                    disabled={!this.setPermissionForResolveNotesButton()}
                    onClick={() => this.resolveNotes()}
                  >
                    Resolve Notes
                  </Button>
                ) : null}
                {observationButton}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="mergeCon hidden-md hidden-lg hidden-sm">
            <Button type="button" onClick={() => this.openFilter(true)} bsStyle="primary">
              Filter
            </Button>
          </div>
        </div>
      </div>
    );
  };

  openFilter = opened => {
    if (opened) {
      this.setState(() => {
        return {
          filterOpen: true
        };
      });
    } else {
      this.setState(() => {
        return {
          filterOpen: false
        };
      });
    }
  };

  setId = e => {
    const params = this.state.params;
    params.id = e.target.value;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setPrecinct = val => {
    const params = this.state.params;
    params.precincts = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setDevice = val => {
    const params = this.state.params;
    params.devices = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setStartDate = e => {
    const params = this.state.params;
    params.start_time = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setEndDate = e => {
    const params = this.state.params;
    params.end_time = e._d ? e._d.toISOString() : "";
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setNoteOrigin = val => {
    const params = this.state.params;
    params.origin = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setStatus = val => {
    const params = this.state.params;
    params.status = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setSensorType = val => {
    const params = this.state.params;
    params.disciplines = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  setAlertType = val => {
    const params = this.state.params;
    params.alert_types = val;
    this.setState(() => {
      return {
        params: params,
        resetFilter: false
      };
    });
  };

  resetFilter = () => {
    this.setState(() => {
      return {
        resetFilter: true,
        params: {},
        showIDInput: false
      };
    });

    // clear selected notes on filter
    this.props.clearSelectedNotes();

    this.getAllNotes();
  };

  renderResetBtn = () => {
    if (this.state.filtered === true) {
      return (
        <a className="pull-right link" onClick={() => this.resetFilter()}>
          Reset filters
        </a>
      );
    } else {
      return null;
    }
  };

  renderPagination = () => {
    if (!this.state.listLoading && this.state.count > this.state.page_size) {
      return (
        <Pagination
          count={this.state.count}
          page_size={this.state.page_size}
          num_pages={this.state.num_pages}
          current_page={this.state.current_page}
          action={this.filterNote}
        />
      );
    } else {
      return null;
    }
  };

  renderIdInput = () => {
    if (this.state.showIDInput) {
      return (
        <FormGroup controlId="formBasicText">
          <ControlLabel>ID</ControlLabel>
          <FormControl type="text" placeholder="Alert ID" name="id" value={this.state.id} onChange={this.setId} />
        </FormGroup>
      );
    }
  };

  isValidStartDate = current => isValidStartDate(current, this.state.params.end_time);

  isValidEndDate = current => isValidEndDate(current, this.state.params.start_time);

  setLoadingState = val => {
    this.setState({ loading: val });
  };

  renderMainContent = data => {
    if (!data) {
      return null;
    }

    const noteCardListToRender = [];
    if (data !== undefined && data.length > 0) {
      _.each(data, item => {
        noteCardListToRender.push(this.createNoteCard(item, item.id));
      });
    }

    let areAllNotesOnPageChecked = this.areAllNotesOnPageChecked();
    if (areAllNotesOnPageChecked === null) {
      areAllNotesOnPageChecked = true;
    }

    return (
      <div className="mainContent card-list">
        <Row>
          <Col md={3} mdPush={9}>
            <div className={"panel-div filter-column" + (this.state.filterOpen ? " filterOpen" : "")}>
              <div className="filterTitle">FILTER NOTES {this.renderResetBtn()}</div>
              <form>
                {this.renderIdInput()}
                <PrecinctDropdown
                  change={this.setPrecinct}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.precincts}
                />
                <DeviceDropdown
                  loading={this.setLoadingState}
                  precinct={this.state.params.precincts}
                  change={this.setDevice}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.devices}
                />
                <DateTimePicker
                  timePeriod="From"
                  changeDate={this.setStartDate}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.start_time}
                  isValidDate={this.isValidStartDate}
                />
                <DateTimePicker
                  timePeriod="To"
                  changeDate={this.setEndDate}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.end_time}
                  isValidDate={this.isValidEndDate}
                />
                <NoteOriginDropdown
                  change={this.setNoteOrigin}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.origin}
                />
                <StatusCheckBox
                  change={this.setStatus}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.status}
                />
                <SensorTypeCheckBox
                  change={this.setSensorType}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.disciplines}
                />
                <AlertTypeCheckBox
                  change={this.setAlertType}
                  reset={this.state.resetFilter}
                  defaultValue={this.state.params.alert_types}
                />
                <div className="buttonContainer">
                  <Button className="btn-cancel" bsStyle="default" onClick={() => this.openFilter(false)}>
                    Cancel
                  </Button>
                  <Button className="btn-filter" bsStyle="primary" onClick={() => this.filterNote()}>
                    Filter
                  </Button>
                </div>
              </form>
            </div>
          </Col>
          <Col md={9} mdPull={3}>
            {this.state.listLoading ? (
              <div className="empty-list">
                <div className="loading2" />
              </div>
            ) : null}
            <div className={this.state.listLoading ? "hide" : ""}>
              {noteCardListToRender.length > 0 ? noteCardListToRender : <div className="empty-list">No Result</div>}
            </div>
            {this.renderPagination()}
          </Col>
        </Row>
      </div>
    );
  };

  renderLoadingPage = () => {
    return (
      <div>
        <MenuBar />
        <FilterMenuBar />
        <div className="map-container">
          <div className="loading" />
        </div>
      </div>
    );
  };

  render() {
    const { noteCreatePermission } = this.props;
    if (this.state.redirect) {
      return <Redirect push to={this.state.redirect} />;
    }

    const data = this.state.allNotesList;
    if (this.state.loading === false) {
      return (
        <div>
          <MenuBar />
          <FilterMenuBar />
          <div className="mainPanelCon">
            <div className="container">
              {this.renderMainTitle(noteCreatePermission, data)}
              {this.renderMainContent(data)}
            </div>
          </div>
          {this.renderModal(this.state.showMapModal, this.handleClose)}
          {this.renderResolveNotesModal(this.state.showResolveNotesModal, this.handleClose)}
        </div>
      );
    } else {
      return <div>{this.renderLoadingPage()}</div>;
    }
  }
}

function mapStateToProps(state) {
  const { configList } = state.configuration;
  const { user } = state.authentication;
  const { noteCreatePermission, noteMergePermission, noteBulkResolvePermission } = state.note;
  const selectedNoteList = state.selectedNotes.selected;
  return {
    configList,
    user,
    noteCreatePermission,
    noteMergePermission,
    noteBulkResolvePermission,
    selectedNoteList
  };
}

export default connect(
  mapStateToProps,
  {
    pageNotes,
    sidebarOff,
    modalAlert,
    selectNotes,
    deselectNotes,
    clearSelectedNotes
  }
)(AllNotePage);



// WEBPACK FOOTER //
// ./src/_components/AllNotePage/index.js